import axios from 'axios';

import { configureAuthInterceptor } from './configureAuthInterceptor';

export const axiosApiInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

configureAuthInterceptor(axiosApiInstance);
